import UserRolesTableContainer from "./UserRolesTableContainer";
export default UserRolesTableContainer;
